import { BaseModel } from '../common/base-model/base-model';

export class Resolution extends BaseModel {
  constructor(
    public override id?: string,
    public name?: string,
    public owner_root_entity_id?: string,
    public target_entity_id?: string,
  ) {
    super();
  }

  static fromJson(jsonData: any): Resolution {
    return Object.assign(new Resolution(), jsonData);
  }
}
